/**
 * Remove Empty Props Utility
 * 
 * Removes null and empty string values from props to allow generated default-props to apply.
 * When CMS fields are empty/null, the component's generated default values should be used.
 * 
 * Examples:
 *   Input:  { title: "Hello", subtitle: "", image: null, nested: { src: null, alt: "" } }
 *   Output: { title: "Hello" }
 *   Result: Component uses generated default-props for subtitle, image, and nested props
 */ /**
 * Recursively removes null and empty string values from an object
 * @param {Object} obj - Props object to clean
 * @returns {Object} Cleaned object without null or empty values
 */ function removeEmptyProps(obj) {
    if (!obj || typeof obj !== 'object' || Array.isArray(obj)) {
        return obj;
    }
    const cleaned = {};
    Object.keys(obj).forEach((key)=>{
        const value = obj[key];
        // Skip null values and empty strings - allows generated default-props to apply
        if (value === null || value === '') {
            return;
        }
        // Recursively clean nested objects
        if (value && typeof value === 'object' && !Array.isArray(value)) {
            const cleanedNested = removeEmptyProps(value);
            // Only include nested object if it has non-empty values
            if (Object.keys(cleanedNested).length > 0) {
                cleaned[key] = cleanedNested;
            }
            return;
        }
        // Include all other values (strings, numbers, booleans, arrays, etc.)
        cleaned[key] = value;
    });
    return cleaned;
}
module.exports = {
    removeEmptyProps
};
